// src/config/categoryTabs.ts
import { IconType } from "react-icons/lib";
import AktiverVerkehr from "../assets/img/landing/tabs/AktiverVerkehr.png";
import AktiverVerkehrmitFCD from "../assets/img/landing/tabs/AktiverVerkehrmitFCD.png";
import RuhenderVerkehrEinzelplatzdetektion from "../assets/img/landing/tabs/Ruhender_Verkehr_Einzelplatzdetektion.png";
import RuhenderVerkehrEinzelplatzdetektionFCD from "../assets/img/landing/tabs/Ruhender_Verkehr_Einzelplatzdetektion_mit_FCD.png";
import RuhenderVerkehrBilanzierendesParken from "../assets/img/landing/tabs/Ruhender_Verkehr_Bilanzierendes_Parken.png";
import RuhenderVerkehrBilanzierendesParkenFCD from "../assets/img/landing/tabs/Ruhender_Verkehr_Bilanzierendes_Parken_mit_FCD.png";
import WiderrechtlichesParken from "../assets/img/landing/tabs/Widerrechtliches_Parken.png";
import Parkscheinautomaten from "../assets/img/landing/tabs/Parkscheinautomaten.png";
import KommunaleMülleimer from "../assets/img/landing/tabs/Kommunale_Mülleimer.png";
import KommunaleBewässerung from "../assets/img/landing/tabs/Kommunale_Bewässerung.png";
import Umwelt from "../assets/img/landing/tabs/Umwelt.png";
import KommunalePegeln from "../assets/img/landing/tabs/Kommunale_Pegeln.png";
import KommunaleGewässerqualität from "../assets/img/landing/tabs/Kommunale_Gewässerqualität.png";
import KommunaleHitzeinseln from "../assets/img/landing/tabs/Kommunale_Hitzeinseln.png";
import KommunaleWald from "../assets/img/landing/tabs/Kommunaler_Wald.png";
import Winterdienst from "../assets/img/landing/tabs/Winterdienst.png";
import DoughnutManagement from "../assets/img/landing/tabs/Doughnut_Management.png";
import Wirtschaft from "../assets/img/landing/tabs/Wirtschaft.png";
import PromptLibraryImage from "../assets/img/landing/tabs/Prompt-Bibliothek.png";

import AktiverVerkehrIcon from "../assets/img/landing/icons/AktiverVerkehrIcon";
import AktiverVerkehrmitFCDIcon from "../assets/img/landing/icons/AktiverVerkehrmitFCDIcon";
import RuhenderVerkehrEinzelplatzdetektionIcon from "../assets/img/landing/icons/Ruhender_Verkehr_Einzelplatzdetektion_Icon";
import RuhenderVerkehrEinzelplatzdetektionFCDIcon from "../assets/img/landing/icons/Ruhender_Verkehr_Einzelplatzdetektion_mit_FCD_Icon";
import Ruhender_Verkehr_Bilanzierendes_Parken_Icon from "../assets/img/landing/icons/Ruhender_Verkehr_Bilanzierendes_Parken_Icon";
import Ruhender_Verkehr_Bilanzierendes_Parken_mit_FCD_Icon from "../assets/img/landing/icons/Ruhender_Verkehr_Bilanzierendes_Parken_mit_FCD_Icon";
import WiderrechtlichesParkenIcon from "../assets/img/landing/icons/Widerrechtliches_Parken_Icon";
import ParkscheinautomatenIcon from "../assets/img/landing/icons/Parkscheinautomaten_Icon";
import KommunaleBewässerungIcon from "../assets/img/landing/icons/Kommunale_Bewässerung_Icon";
import UmweltIcon from "../assets/img/landing/icons/Umwelt_Icon";
import KommunalePegelnIcon from "../assets/img/landing/icons/Kommunale_Pegeln_Icon";
import KommunaleGewässerqualitätIcon from "../assets/img/landing/icons/KommunaleGewässerqualitätIcon";
import KommunaleHitzeinselnIcon from "../assets/img/landing/icons/Kommunale_Hitzeinseln_Icon";
import KommunaleWaldIcon from "../assets/img/landing/icons/Kommunaler_Wald_Icon";
import WinterdienstIcon from "../assets/img/landing/icons/Winterdienst_Icon";
import KommunaleMülleimerIcon from "../assets/img/landing/icons/Kommunale_Mülleimer_Icon";
import DoughnutManagementIcon from "../assets/img/landing/icons/Doughnut_Management_Icon";
import WirtschaftIcon from "../assets/img/landing/icons/Wirtschaft_Icon";
import PromptLibraryIcon from "../assets/img/landing/icons/Promt_Bibliothek";
import HeavyRainIcon from "../assets/img/landing/icons/HeavyRain_Icon";
import HeavyRain from "../assets/img/landing/tabs/HeavyReain.png";
import PassantenaufkommenIcon from "../assets/img/landing/icons/PassantenaufkommenIcon";
import PassantenaufkommenImage from "../assets/img/landing/tabs/Passantenaufkommen.png";
export interface CategoryTab {
  name: string;
  icon: IconType | React.FC<any>;
  defaultTileId: string;
  image: string;
  title: string;
  description: string;
  tooltip: string;
}

export const categoryTabs: Record<string, CategoryTab[]> = {
  traffic: [
    {
      name: "Fließender Verkehr",
      icon: AktiverVerkehrIcon,
      defaultTileId: "SmartTrafficFlow",
      image: AktiverVerkehr,
      title: "categoryTabs.traffic.flowingTraffic.title",
      description: "categoryTabs.traffic.flowingTraffic.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Fließender Verkehr mit FCD",
      icon: AktiverVerkehrmitFCDIcon,
      defaultTileId: "SmartTrafficFlow",
      image: AktiverVerkehrmitFCD,
      title: "categoryTabs.traffic.flowingTrafficFCD.title",
      description: "categoryTabs.traffic.flowingTrafficFCD.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Ruhender Verkehr (Einzelplatzdetektion)",
      icon: RuhenderVerkehrEinzelplatzdetektionIcon,
      defaultTileId: "SmartParkingSpots",
      image: RuhenderVerkehrEinzelplatzdetektion,
      title: "categoryTabs.traffic.staticParkingSingle.title",
      description: "categoryTabs.traffic.staticParkingSingle.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Ruhender Verkehr (Einzelplatzdetektion) mit FCD",
      icon: RuhenderVerkehrEinzelplatzdetektionFCDIcon,
      defaultTileId: "SmartParkingSpots",
      image: RuhenderVerkehrEinzelplatzdetektionFCD,
      title: "categoryTabs.traffic.staticParkingSingleFCD.title",
      description: "categoryTabs.traffic.staticParkingSingleFCD.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Ruhender Verkehr (Bilanzierendes Parken)",
      icon: Ruhender_Verkehr_Bilanzierendes_Parken_Icon,
      defaultTileId: "SmartParking",
      image: RuhenderVerkehrBilanzierendesParken,
      title: "categoryTabs.traffic.staticParkingAggregate.title",
      description: "categoryTabs.traffic.staticParkingAggregate.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Ruhender Verkehr (Bilanzierendes Parken) mit FCD",
      icon: Ruhender_Verkehr_Bilanzierendes_Parken_mit_FCD_Icon,
      defaultTileId: "SmartParking",
      image: RuhenderVerkehrBilanzierendesParkenFCD,
      title: "categoryTabs.traffic.staticParkingAggregateFCD.title",
      description: "categoryTabs.traffic.staticParkingAggregateFCD.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Widerrechtliches Parken",
      icon: WiderrechtlichesParkenIcon,
      defaultTileId: "SmartIllegalParking",
      image: WiderrechtlichesParken,
      title: "categoryTabs.traffic.illegalParking.title",
      description: "categoryTabs.traffic.illegalParking.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Parkscheinautomaten",
      icon: ParkscheinautomatenIcon,
      defaultTileId: "ParkingMeterData",
      image: Parkscheinautomaten,
      title: "categoryTabs.traffic.parkingMeters.title",
      description: "categoryTabs.traffic.parkingMeters.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Passantenaufkommen",
      icon: PassantenaufkommenIcon,
      defaultTileId: "SmartPedestrianOccupancy",
      image: PassantenaufkommenImage,
      title: "categoryTabs.traffic.pedestrianOccupancy.title",
      description: "categoryTabs.traffic.pedestrianOccupancy.description",
      tooltip: "[ui!] DATALAB",
    },
  ],
  environment: [
    {
      name: "Kommunale Mülleimer",
      icon: KommunaleMülleimerIcon,
      defaultTileId: "SmartWasteDisposal",
      image: KommunaleMülleimer,
      title: "categoryTabs.environment.wasteBins.title",
      description: "categoryTabs.environment.wasteBins.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Kommunale Bewässerung",
      icon: KommunaleBewässerungIcon,
      defaultTileId: "SmartEnvironment",
      image: KommunaleBewässerung,
      title: "categoryTabs.environment.irrigation.title",
      description: "categoryTabs.environment.irrigation.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Umwelt",
      icon: UmweltIcon,
      defaultTileId: "SmartNoise",
      image: Umwelt,
      title: "categoryTabs.environment.environment.title",
      description: "categoryTabs.environment.environment.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Kommunale Pegel",
      icon: KommunalePegelnIcon,
      defaultTileId: "SmartWaterLevel",
      image: KommunalePegeln,
      title: "categoryTabs.environment.waterLevel.title",
      description: "categoryTabs.environment.waterLevel.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Kommunale Gewässerqualität",
      icon: KommunaleGewässerqualitätIcon,
      defaultTileId: "SmartWaterQuality",
      image: KommunaleGewässerqualität,
      title: "categoryTabs.environment.waterQuality.title",
      description: "categoryTabs.environment.waterQuality.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Kommunale Hitzeinseln",
      icon: KommunaleHitzeinselnIcon,
      defaultTileId: "HeatIsland",
      image: KommunaleHitzeinseln,
      title: "categoryTabs.environment.heatIslands.title",
      description: "categoryTabs.environment.heatIslands.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Kommunaler Wald",
      icon: KommunaleWaldIcon,
      defaultTileId: "ForestFireVulnerability",
      image: KommunaleWald,
      title: "categoryTabs.environment.forest.title",
      description: "categoryTabs.environment.forest.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Winterdienst",
      icon: WinterdienstIcon,
      defaultTileId: "SmartNaturalEvents",
      image: Winterdienst,
      title: "categoryTabs.environment.winterService.title",
      description: "categoryTabs.environment.winterService.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Starkregen",
      icon: HeavyRainIcon,
      defaultTileId: "SmartSurfaceWater",
      image: HeavyRain,
      title: "categoryTabs.environment.heavyRain.title",
      description: "categoryTabs.environment.heavyRain.description",
      tooltip: "[ui!] DATALAB",
    },
  ],
  utility: [
    {
      name: "Doughnut Management",
      icon: DoughnutManagementIcon,
      defaultTileId: "Questionnaire",
      image: DoughnutManagement,
      title: "categoryTabs.utility.doughnut.title",
      description: "categoryTabs.utility.doughnut.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Wirtschaft",
      icon: WirtschaftIcon,
      defaultTileId: "SpendingPulse",
      image: Wirtschaft,
      title: "categoryTabs.utility.economy.title",
      description: "categoryTabs.utility.economy.description",
      tooltip: "[ui!] DATALAB",
    },
    {
      name: "Prompt Bibliothek",
      icon: PromptLibraryIcon,
      defaultTileId: "PromptLibrary",
      image: PromptLibraryImage,
      title: "categoryTabs.utility.promptLibrary.title",
      description: "categoryTabs.utility.promptLibrary.description",
      tooltip: "[ui!] DATALAB",
    },
  ],
};
